import { useContext } from 'react';
import styles from './installation.module.css';

import { MANIFEST_ICON_URL } from '@/constants';
import config from '@/config';
import { AppContext } from '@/app.context';
import { TrackingContext } from '@shared/tracking';
import { Button } from '@shared/ui/button';
import { promptInstall } from '../model/prompt-install';

export const Installation = ({ show, onCloseClick }: InstallationProps) => {
	if (!show) {
		return null;
	}
	/*if (localStorage.getItem('showed-installation-option')) {
		return null;
	}
	if (config?.app?.installationOption?.enabled === false) {
		return null;
	}*/
	return (
		<div className={styles['installation-dialog']}>
			<div className={styles['container']}>
				<div className={styles['close-container']}>
					<CloseBtn onClick={onCloseClick} />
				</div>
				<div className={styles['content']}>
					<div>
						<img src={MANIFEST_ICON_URL} alt="logo" />
						<h3>
							Install <i>{config.build.title}</i>
						</h3>
						<p>
							Install this application on your home screen for
							quick and easy access when you are on the go.
						</p>
					</div>
					<div>
						Just tap <Share /> icon and Add to Home Screen
					</div>
				</div>
			</div>
		</div>
	);
};

interface InstallationProps {
	show: boolean;
	onCloseClick: () => void;
}

interface NavigatorWithStandalone extends Navigator {
	standalone?: boolean;
}

export function isStandAlone(): boolean {
	const navigator = window?.navigator as NavigatorWithStandalone;
	if (navigator.standalone) {
		return true;
	}

	return window.matchMedia('(display-mode: standalone)').matches;
}

function CloseBtn({ onClick }: CloseBtnProps) {
	return (
		<button type="button" title="Close" aria-label="Close" onClick={onClick}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<line x1="18" y1="6" x2="6" y2="18"></line>
				<line x1="6" y1="6" x2="18" y2="18"></line>
			</svg>
		</button>
	);
}

interface CloseBtnProps {
	onClick: () => void;
}

export function Share() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
			<polyline points="16 6 12 2 8 6"></polyline>
			<line x1="12" y1="2" x2="12" y2="15"></line>
		</svg>
	);
}

export function InstallBtn({
	onClick,
	className,
}: {
	onClick: () => void;
	className?: string;
}) {
	const { isSupportInstallPrompt, deferredPrompt } = useContext(AppContext);
	const { sendEvent } = useContext(TrackingContext);

	if (isStandAlone()) {
		return null;
	}

	if (!isSafari() && !isSupportInstallPrompt) {
		return null;
	}

	if (!isSafari() && deferredPrompt === undefined) {
		return null;
	}

	const classNames = [styles['install-btn']];
	if (className) {
		classNames.push(className);
	}

	if (!isSupportInstallPrompt || !deferredPrompt) {
		return (
			<Button
				type="button"
				className={classNames.join(' ')}
				onClick={() => {
					sendEvent({
						type: 'BTN_CLICK_INSTALL',
					});
					onClick();
				}}
			>
				Install
			</Button>
		);
	}

	return (
		<Button
			type="button"
			className={classNames.join(' ')}
			onClick={() => {
				sendEvent({
					type: 'BTN_CLICK_INSTALL',
				});
				void promptInstall(deferredPrompt, sendEvent);
			}}
		>
			Install
		</Button>
	);
}

function isSafari() {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
